// extracted by mini-css-extract-plugin
export var calendarView = "_nr-0";